import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DocsService, ICreateMappingBookRequest, IDbMappingBook } from '@shared/services/docs.service';

import { tagArray, TagsService } from '@shared/services/tags.service';
import { firstValueFrom, take } from 'rxjs';

@Component({
	selector: 'app-create-mapping',
	templateUrl: './create-mapping.component.html',
	styleUrls: ['./create-mapping.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateMappingComponent {
	@Output() mappingCreated: EventEmitter<any> = new EventEmitter();
	mappingBook: ICreateMappingBookRequest = { tags: {} }; // Object to POST
	tagsString: string = ''; // String representation of tags
	systemMappings: any[] = []; // Array to hold system specific mappings
	tagsErrorMessage: string | null;

	constructor(
		private docsService: DocsService,
		public dialogRef: MatDialogRef<CreateMappingComponent>,
		@Inject(MAT_DIALOG_DATA) public InjectMappingBook: IDbMappingBook,
		private translate: TranslateService,
		private validator: TagsService,
	) {}

	onNoClick(): void {
		this.dialogRef.close();
	}

	onEdit(_: any) {
		this.tagsErrorMessage = this.validator.validateTags(this.tagsString);
	}

	async onSaveClick() {
		const tagsDictionary: tagArray = {};
		const mappingsDictionary: tagArray = {};

		const tagsArray = this.tagsString.split(',');
		tagsArray.forEach((tag) => {
			const [key, value] = tag.split('=');
			tagsDictionary[key.trim()] = value.trim();
		});

		this.systemMappings.forEach((item) => {
			mappingsDictionary[item.key] = item.value;
		});

		const createMappingBook: ICreateMappingBookRequest = {
			tags: tagsDictionary,
			mappingDocument: {
				'--systemspecificmappings--': mappingsDictionary,
			},
		};

		await firstValueFrom(this.docsService.createMappingBook(createMappingBook).pipe(take(1)));

		this.mappingCreated.emit();
		this.dialogRef.close();
	}

	editTags() {
		this.mappingBook.tags = this.tagsString.split(',').map((tag) => {
			const [key, value] = tag.split(':');
			return { key, value };
		});
	}

	addRow() {
		this.systemMappings.push({ key: '', value: '' });
	}

	deleteRow(index: number) {
		this.systemMappings.splice(index, 1);
	}
}
